import React from 'react';
import { useParams ,Navigate } from "react-router-dom";
import { useLocalization } from '../../utils/hooks/useLocalization'
import { useLightbox } from '../../utils/hooks/useLightbox';
import { ZoomIn } from 'lucide-react';
import Socials from '../../components/Socials/Socials';
import styles from './ArtistBioPage.module.css';
import artists from "../../data/artist";
import SlickSliderText from '../../components/SlickSliderText/slickSliderText';



const ArtistBioPage = ({ isMobile }) => {
  const { t, currentLanguage } = useLocalization();
  const { artistId } = useParams();
  
  const artist = artists.items.find(
    (a) => a.id === artistId && a.show && a.active);

  // Resolved here so the lightbox stays ignorant of the repo-root images/ folder.
  // id_photos[0] is the profile picture, not portfolio work, so it is shown on
  // its own and left out of the gallery.
  const photos = (artist?.id_photos || []).map((path) => require(`../../../images/${path}`));
  const portfolio = photos.slice(1);
  const { triggerProps, lightbox } = useLightbox({
    images: portfolio,
    name: artist?.name || '',
    label: (i) => `${artist?.nickName} ${i + 1} - ${t('product_detail_gallery_zoom')}`,
  });

    if (!artist) {
        return <Navigate to={`/artists`} replace />
    }


  const statements = artist.statement.map(item => ({
    title: item.title[currentLanguage],
    description: item.description[currentLanguage]
  }));
 

  return (
    <section id="products" className={styles.artistBio}>
        <div className={styles.container}>
          <div className={isMobile ? styles.bioContainerMobile : styles.bioContainer}>
            <img
              src={photos[0]}
              alt={artist.name}
              className={styles.artistMainImage}
            />
            <div className={styles.bioBox}>
              <div className={isMobile ? styles.headerBioBoxMobile : styles.headerBioBox}>
                <div>
                  <h2 className={isMobile ? styles.artistNickNameMobile : styles.artistNickName}>{artist.nickName}</h2>
                  <h4 className={styles.artistName}>{artist.name}</h4>
                </div>

                <div className={isMobile ? styles.socialsIconsMobile : styles.socialsIcons}>
                  <Socials artistSocials={artist.social} />
                </div>
              </div>
              <SlickSliderText className={styles.slider} paragraphs={statements} isMobile={isMobile} />
              
            </div>
          </div>
          <div className={isMobile ? styles.imagesContainerMobile : styles.imagesContainer}>
            {portfolio.map((src, index) => (
              <a key={src} {...triggerProps(index)} className={styles.zoomCell}>
                <img
                  src={src}
                  alt={artist.name}
                  className={styles.artistImage}
                  loading="lazy"
                  decoding="async"
                />
                <span className={styles.zoomOverlay} aria-hidden="true">
                  <ZoomIn size={28} />
                </span>
              </a>
            ))}
          </div>
          {lightbox}
        </div>
      </section>
  );
};

export default ArtistBioPage;